import { useEffect, useState } from "react";

import type { IDiscountTimeParams, ITimeLeft } from "app/components/React/TrialBanner/DiscountBanner/utils/consts";
import { COUNTDOWN_INTERVAL } from "app/components/timers/utils/consts";
import { calculateTimeLeft, getIsExpired } from "app/components/timers/utils/helpers";

export const useTimeLeft = ({ discountEndDateFromSettings, discountEndTime }: IDiscountTimeParams): ITimeLeft => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft({ discountEndDateFromSettings, discountEndTime }));

    useEffect(() => {
        if (getIsExpired(timeLeft)) {
            return;
        }

        const intervalId = setInterval(() => {
            const newTimeLeft = calculateTimeLeft({ discountEndDateFromSettings, discountEndTime });
            setTimeLeft(newTimeLeft);
            if (getIsExpired(newTimeLeft)) {
                clearInterval(intervalId);
            }
        }, COUNTDOWN_INTERVAL);

        return () => clearInterval(intervalId);
    }, [discountEndDateFromSettings, discountEndTime]);
    return timeLeft;
};
